module.exports = __webpack_public_path__ + "img/bakingIngredient6.13200aec.jpeg";